import React from 'react';
import { Row, Modal } from 'react-bootstrap';
import { makeStyles } from "@material-ui/core/styles";
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import "./ProductModal.scss";

const useStyles = makeStyles(theme => ({
    productModalHighlighted: {
        zIndex:'1400'
    },
    textColor: {
      color: theme.palette.primary.main,
    },
}));

export default function ProductModal(props) {
    const classes = useStyles();

    const {rider, title, description, additionalCost} = props.productData;

    return (
        <Modal show={props.productModalShow} className={classes.productModalHighlighted} onHide={() => {props.setProductModalShow(false)}} backdrop={true} size="md" centered scrollable={true}>
            <Modal.Header className="header-content" closeButton>
              <h1>{rider ? rider : title}</h1>
              
                {rider && additionalCost && (
                  <p className={`rider-cost ${classes.textColor}`}>
                    <MonetizationOnOutlinedIcon /> <span className="addtional">Requires Additional Cost</span>
                  </p>
                )}
                {rider && !additionalCost && (
                  <p className={`rider-cost ${classes.textColor}`}>
                    <MonetizationOnOutlinedIcon /> <span className={`noAddtional `}>No Additional Cost</span>
                  </p>
                )}
            </Modal.Header>
            <Modal.Body className="body-content">
              {rider && <p className="note">Riders add benefits to or change the term of an insurance policy.</p>}
              <div className="description" dangerouslySetInnerHTML={{ __html: description }}></div>
            </Modal.Body>
        </Modal>
    )
}


// WEBPACK FOOTER //
// ./src/components/Quoters/CustomizeTerm/Common/ProductModal.js